@use "../../../../styles/Colors.scss" as Colors;
@use "../../../../styles/Constants.scss" as Constants;

.resource {
	&__popover {
		max-width: none;
		width: initial;

		& .popover-content {
			padding: Constants.$val-spacing-s;
		}
	}

	&-tooltip {
		&__container {
			display: flex;
			align-items: center;
			flex-flow: row nowrap;
			flex: 1;
		}

		&__resource-container {
			display: flex;
			flex-flow: column nowrap;
			justify-content: flex-start;
			font-size: Constants.$val-fontSizeSmall;
			align-self: stretch;

			&:first-child {
				text-align: left;
				margin-right: Constants.$val-spacing-m;
				padding-right: Constants.$val-spacing-m;
				border-right: 1px solid Colors.$col-white;
			}

			&:last-child {
				text-align: right;
				margin-left: Constants.$val-spacing-m;
				padding-left: Constants.$val-spacing-m;
				border-left: 1px solid Colors.$col-white;
			}
		}

		&__resource-item {
			white-space: nowrap;
		}
	}
}
